import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbWhatsAppBusiness } from 'app/abstract/full-pages/integrador/whatsapp-business.abstract';
import {
  MetaBusinessResponse,
  EmbeddedSignupStateResponse, MetaBusinessPatchRequest,
  MetaBusinessPatchResponse,
  MetaBusinessDeleteResponse,
  MetaBusinessTemplate,
  MetaBusinessMensagemRequest,
  MetaBusinessMensagemResponse,
  MetaBusinessAccountsGetResponse,
  MetaBusinessAccountsPostResponse,
  MetaBusinessAccountsPostRequest,
  MetaBusinessAccountsDeleteRequest,
  MensagemTesteHistoricoResponse
} from './models/whatsapp-business.models';


@Injectable({ providedIn: 'root' })
export class WhatsAppBusinessService extends AbWhatsAppBusiness {

  private readonly basePath = 'admin/v1/integrador/meta-business';

  constructor(http: HttpClient){
    super(http);
  }

  consultarStatus(): Observable<MetaBusinessResponse> {
    return this.http.get<MetaBusinessResponse>(`${this.url}${this.basePath}`);
  }

  gerarState(): Observable<EmbeddedSignupStateResponse> {
    return this.post(`${this.basePath}/state`, {});
  }

  completarCadastro(dados: MetaBusinessPatchRequest): Observable<MetaBusinessResponse> {
    return this.post(`${this.basePath}/complete`, dados);
  }

  atualizarIntegracao(dados: MetaBusinessPatchRequest): Observable<MetaBusinessPatchResponse> {
    return this.http.patch<MetaBusinessPatchResponse>(
      `${this.url}${this.basePath}`, dados
    );
  }

  removerIntegracao(metaPhoneNumberId: string): Observable<MetaBusinessDeleteResponse> {
    return this.http.delete<MetaBusinessDeleteResponse>(
      `${this.url}${this.basePath}`, { params: { metaPhoneNumberId } }
    );
  }

  buscarTemplate(): Observable<MetaBusinessTemplate> {
    return this.http.get<MetaBusinessTemplate>(`${this.url}${this.basePath}/simulacao/template`);
  }

  enviarMensagemTeste(dados: MetaBusinessMensagemRequest): Observable<MetaBusinessMensagemResponse> {
    return this.post(`${this.basePath}/mensagens`, dados);
  }

  reenviarTemplates(): Observable<MetaBusinessResponse> {
    return this.post(`${this.basePath}/templates/rebuild`, {});
  }

  buscarContas(): Observable<MetaBusinessAccountsGetResponse> {
    return this.getAll<MetaBusinessAccountsGetResponse>(`${this.basePath}/accounts`);
  }

  cadastrarContas(contas: MetaBusinessAccountsPostRequest): Observable<MetaBusinessAccountsPostResponse> {
    return this.http.post<MetaBusinessAccountsPostResponse>(`${this.url}${this.basePath}/accounts`, contas)
  }

  excluirContas(contas: MetaBusinessAccountsDeleteRequest): Observable<void> {
    return this.http.delete<void>(`${this.url}${this.basePath}/accounts`, { body: contas })
  }

  buscarHistoricoMensagens(): Observable<MensagemTesteHistoricoResponse> {
    return this.http.get<MensagemTesteHistoricoResponse>(`${this.url}${this.basePath}/mensagens/historico`);
  }
}
